import { render, staticRenderFns } from "./index_mobile.vue?vue&type=template&id=39c6086d&scoped=true"
import script from "./index_mobile.vue?vue&type=script&lang=js"
export * from "./index_mobile.vue?vue&type=script&lang=js"
import style0 from "./index_mobile.vue?vue&type=style&index=0&id=39c6086d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39c6086d",
  null
  
)

export default component.exports